module.exports = __webpack_public_path__ + "img/payment-paypal.4d56139c.png";